import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid-container" }
const _hoisted_2 = { class: "content min-height m-3" }
const _hoisted_3 = { class: "back-grid" }
const _hoisted_4 = { class: "flex flex-column lg:flex-row xl:align-items-center" }
const _hoisted_5 = { class: "flex-shrink-1 flex-grow-0 mr-3 layout-button" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "flex flex-direction-column lg:flex-row mr-auto ml-auto text-align-center align-center" }
const _hoisted_8 = { class: "gallery col-12 sm:col-6 lg:col-12 xl:col-3 p-0" }
const _hoisted_9 = {
  key: 0,
  class: "w-100"
}
const _hoisted_10 = {
  key: 1,
  class: "w-100"
}
const _hoisted_11 = { class: "gallery col-12 sm:col-6 lg:col-12 xl:col-3 p-0 m-1" }
const _hoisted_12 = {
  key: 0,
  class: "w-100"
}
const _hoisted_13 = {
  key: 1,
  class: "w-100"
}
const _hoisted_14 = { class: "gallery col-12 sm:col-6 lg:col-12 xl:col-3 p-0" }
const _hoisted_15 = {
  key: 0,
  class: "w-100"
}
const _hoisted_16 = {
  key: 1,
  class: "w-100"
}
const _hoisted_17 = { class: "mt-1" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "padding-10 mt-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "number" }
const _hoisted_23 = { class: "image-container" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  id: "profile-img",
  src: "//ssl.gstatic.com/accounts/ui/avatar_2x.png",
  class: "recommendation-img-card"
}
const _hoisted_26 = { class: "flex-grow-1" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  id: "courseSupportDropdown",
  class: "form-control"
}
const _hoisted_30 = { class: "flex-grow-0 flex-shrink-0 mr-3 more-details" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "flex-grow-0 flex-shrink-0 mr-5" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "table" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "table" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "data-view-container" }
const _hoisted_46 = { class: "cursor-pointer" }
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 1,
  id: "profile-img",
  src: "//ssl.gstatic.com/accounts/ui/avatar_2x.png",
  class: "recommendation-img-card"
}
const _hoisted_49 = { class: "text-align-center text-wrap" }
const _hoisted_50 = { class: "bold-text" }
const _hoisted_51 = { class: "bold-text" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "flex flex-direction-column justify-content-between text-align-center mt-2" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "table" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "table" }
const _hoisted_63 = ["href"]
const _hoisted_64 = ["href"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = { class: "form-group text-align-center" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "spinner-border spinner-border-sm" }
const _hoisted_73 = { style: {"text-align":"left"} }
const _hoisted_74 = {
  class: "bold-text",
  style: {"font-size":"x-large"}
}
const _hoisted_75 = { class: "table" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "table" }
const _hoisted_79 = ["href"]
const _hoisted_80 = ["href"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { style: {"text-align":"left"} }
const _hoisted_85 = {
  class: "bold-text",
  style: {"font-size":"x-large"}
}
const _hoisted_86 = { class: "table" }

import { ref, watch, onMounted, onUnmounted, reactive } from "vue";
import { showToast, websiteURL, valid } from "@/utils";
import * as yup from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";
import Dialog from "primevue/dialog";
import InstructorSidebar from "@/components/instructor/InstructorSidebar.vue";
import BackButton from "@/components/user/BackButton.vue";
import RecommendationGalleryItem from "@/components/instructor/RecommendationGalleryItem.vue";
import DataView from "primevue/dataview";
import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
import { useCourseStore } from "@/stores/CourseStore";
import { useRecommendationsStore } from "@/stores/RecommendationsStore";
import { useAuthStore } from "@/stores/AuthStore";
import { useFeedStore } from "@/stores/FeedStore";
import { useRouter } from "vue-router";
import InstructorService from "@/services/instructor.service.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendationsView',
  setup(__props) {

const CourseStore = useCourseStore();
const RecommendationsStore = useRecommendationsStore();
const AuthStore = useAuthStore();
const FeedStore = useFeedStore();
const router = useRouter();

let loading = ref(false);
let message = ref("");
let successful = ref(false);
let isVisible = ref(false);
let showCourseSupportDetails = ref(false);
let isPractitionerDetailsVisible = ref(false);
let isPractitionerExperienceVisible = ref(false);
let currIndustryPractitioner = ref({});
let pastExperienceData = ref([]);
const currentUser = AuthStore.auth;
const recommendations = RecommendationsStore.recommendations || [];

const showPopup = () => {
  isVisible.value = true;
};

const schema = yup.object().shape({
  msg: yup.string().required("Message to practitioner  is required!"),
});

const getCustomMsg = () => {
  if (currentUser.phone === "True") {
    return `I ${currentUser.title} ${currentUser.firstName} ${currentUser.lastName} wants you to provide a course-support (${course.courseRequestType}). You can reach me at ${currentUser.email} or ${currentUser.phoneNumber}.`;
  } else {
    return `I ${currentUser.title} ${currentUser.firstName} ${currentUser.lastName} wants you to provide a course-support (${course.courseRequestType}). You can reach me at ${currentUser.email}.`;
  }
};

const handleClick = () => {
  router.push({ name: "instructor-feed" });
};

const course = reactive(CourseStore.course || {});

const checkCourseRequestType = () => {
  const intervalId = setInterval(() => {
    // Dynamically fetch course from CourseStore in each iteration
    const course = CourseStore.course;
    if (course.courseRequestType) {
      RecommendationsStore.setRecommendations(course);
      // Clear the interval once we get the courseRequestType
      clearInterval(intervalId);
    }
  }, 500); // 0.5 seconds interval
  // Cleanup the interval when the component is unmounted
  onUnmounted(() => {
    clearInterval(intervalId);
  });
};
// Run the check when the component is mounted
onMounted(() => {
  checkCourseRequestType();
});

const selectIndustryPractitioner = (practitioner) => {
  practitioner.opened = false;
  RecommendationsStore.selectPractitioner(practitioner.id);
  RecommendationsStore.$persist();
};

const saveSelectedPractitioners = (data) => {
  loading.value = true;
  InstructorService.selectIndustryPractitioner(
    course,
    RecommendationsStore.selectedPractitioner,
    data["msg"],
    RecommendationsStore.recommendations.map((el) => el.id)
  ).then(
    (response) => {
      loading.value = false;
      showToast("Message sent successfully to selected industry practitioner.");
      router.push({ name: "home" });
    },
    (error) => {
      loading.value = false;
      message.value =
        (error.response &&
          error.response.data &&
          error.response.items.message) ||
        error.message ||
        error.toString();
    }
  );
};

const getPractitionerExperience = (e, industryPractitioner) => {
  e.stopPropagation();

  // If the dropdown is already open, just close it
  if (industryPractitioner.showCourseSupportDetails) {
    industryPractitioner.showCourseSupportDetails = false;
    return;
  }

  // Otherwise, fetch the details and open it
  loading.value = true;

  InstructorService.getPastExperienceDetails(industryPractitioner.id).then(
    (response) => {
      console.log(response.data);
      pastExperienceData.value = response.data; // Populate the dropdown data

      // Toggle the dropdown visibility for the current practitioner
      industryPractitioner.showCourseSupportDetails = true;
      loading.value = false;
    },
    (error) => {
      loading.value = false;
      console.error(error);
    }
  );
};

const windowResize = () => {
  if (window.innerWidth < 600) {
    FeedStore.recommendationLayout = "grid";
  }
};

windowResize();
window.addEventListener("resize", windowResize);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(InstructorSidebar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: handleClick,
            style: {"background":"none","border":"none","outline":"none","padding":"0","cursor":"pointer","font-weight":"bold"},
            title: "Go back"
          }, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "chevron-left",
              style: {"font-weight":"bold"}
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" Back "))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", null, [
              _createElementVNode("h2", {
                style: {"text-align":"center","font-weight":"bold"},
                class: "flex-grow-1"
              }, " View Recommendations "),
              _createElementVNode("h5", { style: {"text-align":"center"} }, " You will be provided with the contact information of the practitioner(s) you selected. ")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(DataViewLayoutOptions), {
                modelValue: _unref(FeedStore).recommendationLayout,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FeedStore).recommendationLayout) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "bold-text" }, " A maximum of 3 selections is allowed. If the first practitioner declines, your request goes to next practitioner. ", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(RecommendationsStore).selectedPractitioner.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(RecommendationGalleryItem, {
                      "selected-practitioner": 
                  _unref(RecommendationsStore).selectedPractitioner[0]
                ,
                      title: "1st Choice Practitioner"
                    }, null, 8, ["selected-practitioner"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "1st Practitioner"))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_unref(RecommendationsStore).selectedPractitioner.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(RecommendationGalleryItem, {
                      "selected-practitioner": 
                  _unref(RecommendationsStore).selectedPractitioner[1]
                ,
                      title: "2nd Choice Practitioner"
                    }, null, 8, ["selected-practitioner"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "2nd Practitioner"))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_unref(RecommendationsStore).selectedPractitioner.length > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(RecommendationGalleryItem, {
                      "selected-practitioner": 
                  _unref(RecommendationsStore).selectedPractitioner[2]
                ,
                      title: "3rd Choice Practitioner"
                    }, null, 8, ["selected-practitioner"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, "3rd Practitioner"))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: _unref(RecommendationsStore).selectedPractitioner.length === 0,
                onClick: showPopup
              }, " Save Choices ", 8, _hoisted_18)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_unref(RecommendationsStore).recommendations.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_unref(DataView), {
                  value: _unref(RecommendationsStore).recommendations || [],
                  layout: _unref(FeedStore).recommendationLayout
                }, {
                  list: _withCtx((slotProps) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items.slice(0, 10), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["w-100", { disabled: item.disabled }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex flex-column xl:flex-row xl:align-items-center p-4 gap-4 flex-grow-1", { 'pointer-events-none': item.disabled }])
                        }, [
                          _createElementVNode("div", {
                            class: "flex flex-column xl:flex-row xl:align-items-center cursor-pointer",
                            onClick: ($event: any) => (item.opened = !item.opened)
                          }, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(index + 1), 1),
                            _createElementVNode("div", _hoisted_23, [
                              (item.fileName)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    id: "profile-img",
                                    src: _unref(websiteURL) + 'profile_picture/' + item.fileName,
                                    class: "recommendation-img-card"
                                  }, null, 8, _hoisted_24))
                                : (_openBlock(), _createElementBlock("img", _hoisted_25))
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("b", null, _toDisplayString(item.title) + " " + _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName) + ", " + _toDisplayString(item.city) + " " + _toDisplayString(item.state), 1),
                              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                              _cache[9] || (_cache[9] = _createElementVNode("b", null, "Position:", -1)),
                              _createTextVNode(" " + _toDisplayString(item.position) + " at " + _toDisplayString(item.nameOrg) + " ", 1),
                              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                              _cache[11] || (_cache[11] = _createElementVNode("b", null, "Area of Specialization:", -1)),
                              _createTextVNode(" " + _toDisplayString(JSON.parse(item.expertise || "[]").join(", ")) + " ", 1),
                              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                              _cache[13] || (_cache[13] = _createElementVNode("b", null, "Years of Experience:", -1)),
                              _createTextVNode(" " + _toDisplayString(item.yearsOfExp) + " ", 1),
                              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", null, [
                                (item.pastExperience > 0)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      onClick: ($event: any) => (getPractitionerExperience($event, item)),
                                      class: "past-exp-button"
                                    }, [
                                      _cache[7] || (_cache[7] = _createElementVNode("b", null, "Previous course-support provided:", -1)),
                                      _createTextVNode(" " + _toDisplayString(item.pastExperience), 1)
                                    ], 8, _hoisted_27))
                                  : _createCommentVNode("", true),
                                (
                            item.showCourseSupportDetails &&
                            _unref(pastExperienceData).length > 0
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("select", _hoisted_29, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pastExperienceData), (data, index) => {
                                          return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(data.courseRequestType) + " (" + _toDisplayString(data.count_exp) + ") ", 1))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              (item.opened)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-up" })
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-sm" }, "View Details", -1)),
                                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-down" })
                                  ]))
                            ])
                          ], 8, _hoisted_21),
                          _createElementVNode("div", _hoisted_33, [
                            (
                        course.status !== '20' &&
                        course.status !== '10' &&
                        course.status !== '60'
                      )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-primary",
                                  onClick: ($event: any) => (selectIndustryPractitioner(item))
                                }, " Select Practitioner ", 8, _hoisted_34))
                              : _createCommentVNode("", true)
                          ])
                        ], 2),
                        _createVNode(_Transition, null, {
                          default: _withCtx(() => [
                            (item.opened)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Basic Information ", -1)),
                                  _createElementVNode("table", _hoisted_36, [
                                    _createElementVNode("tr", null, [
                                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "Name", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[17] || (_cache[17] = _createElementVNode("td", null, "Title", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.title), 1)
                                    ]),
                                    (_unref(valid)(item.pronouns))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                          _cache[18] || (_cache[18] = _createElementVNode("td", null, "Pronouns", -1)),
                                          _createElementVNode("td", null, _toDisplayString(item.pronouns), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(valid)(item.position))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                                          _cache[19] || (_cache[19] = _createElementVNode("td", null, "Position", -1)),
                                          _createElementVNode("td", null, _toDisplayString(item.position), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("tr", null, [
                                      _cache[20] || (_cache[20] = _createElementVNode("td", null, "Years of Experience", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.yearsOfExp), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[21] || (_cache[21] = _createElementVNode("td", null, "Level of Education", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.levelEducation), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[22] || (_cache[22] = _createElementVNode("td", null, "Area of Specialization", -1)),
                                      _createElementVNode("td", null, _toDisplayString(JSON.parse(item.expertise || "[]").join(", ")), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[23] || (_cache[23] = _createElementVNode("td", null, "Professional License", -1)),
                                      _createElementVNode("td", null, _toDisplayString(JSON.parse(item.profLicense || "[]").join(", ")), 1)
                                    ])
                                  ]),
                                  _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Organization Basic Information ", -1)),
                                  _createElementVNode("table", _hoisted_39, [
                                    _createElementVNode("tr", null, [
                                      _cache[24] || (_cache[24] = _createElementVNode("td", null, "Organization", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.nameOrg), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[25] || (_cache[25] = _createElementVNode("td", null, "Location", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.city) + " " + _toDisplayString(item.state), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[26] || (_cache[26] = _createElementVNode("td", null, "Type of Organization", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.type), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[27] || (_cache[27] = _createElementVNode("td", null, "Size of Organization", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.size), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[28] || (_cache[28] = _createElementVNode("td", null, "Gender Diversity", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.genderDiv), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[29] || (_cache[29] = _createElementVNode("td", null, "Racial Diversity", -1)),
                                      _createElementVNode("td", null, _toDisplayString(item.ethnicDiv), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[30] || (_cache[30] = _createElementVNode("td", null, "Website", -1)),
                                      _createElementVNode("td", null, [
                                        (!item.website.startsWith('http'))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              href: 'https://' + item.website,
                                              target: "_blank"
                                            }, _toDisplayString(item.website), 9, _hoisted_40))
                                          : (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: item.website,
                                              target: "_blank"
                                            }, _toDisplayString(item.website), 9, _hoisted_41))
                                      ])
                                    ]),
                                    (_unref(valid)(item.typeProject))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                          _cache[31] || (_cache[31] = _createElementVNode("td", null, "Types of Projects", -1)),
                                          _createElementVNode("td", null, _toDisplayString(JSON.parse(item.typeProject || "[]").join(", ")), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(valid)(item.typeTechnology))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                          _cache[32] || (_cache[32] = _createElementVNode("td", null, "Technologies Used", -1)),
                                          _createElementVNode("td", null, _toDisplayString(JSON.parse(item.typeTechnology || "[]").join(", ")), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(valid)(item.organPolicy))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                          _cache[33] || (_cache[33] = _createElementVNode("td", null, "Support Policy", -1)),
                                          _createElementVNode("td", null, _toDisplayString(item.organPolicy), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2))
                    }), 128))
                  ]),
                  grid: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items.slice(0, 10), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["border-1 surface-border surface-card border-round p-2", {
                    disabled: item.disabled,
                    'pointer-events-none': item.disabled,
                  }])
                        }, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", null, [
                              (item.fileName)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    id: "profile-img",
                                    src: _unref(websiteURL) + 'profile_picture/' + item.fileName,
                                    class: "recommendation-img-card"
                                  }, null, 8, _hoisted_47))
                                : (_openBlock(), _createElementBlock("img", _hoisted_48))
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, _toDisplayString(item.title) + " " + _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                              _createElementVNode("div", _hoisted_51, _toDisplayString(item.position) + " at " + _toDisplayString(item.nameOrg) + ", " + _toDisplayString(item.city) + " " + _toDisplayString(item.state), 1),
                              _createElementVNode("div", null, [
                                _cache[38] || (_cache[38] = _createElementVNode("b", null, "Area of specialization:", -1)),
                                _createTextVNode(" " + _toDisplayString(item.expertise
                            ? JSON.parse(item.expertise || "[]").join(", ")
                            : "N/A") + " ", 1),
                                _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                                _cache[40] || (_cache[40] = _createElementVNode("b", null, "Years of experience:", -1)),
                                _createTextVNode(" " + _toDisplayString(item.yearsOfExp || "N/A") + " ", 1),
                                (item.pastExperience > 0)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      onClick: ($event: any) => (getPractitionerExperience($event, item)),
                                      class: "past-exp-button"
                                    }, [
                                      _cache[36] || (_cache[36] = _createElementVNode("b", null, "Previous course-support provided:", -1)),
                                      _createTextVNode(" " + _toDisplayString(item.pastExperience), 1)
                                    ], 8, _hoisted_52))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _cache[37] || (_cache[37] = _createElementVNode("b", null, "Previous course-support provided:", -1)),
                                      _createTextVNode(" " + _toDisplayString(item.pastExperience), 1)
                                    ]))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", {
                              class: "more-details",
                              onClick: ($event: any) => (item.opened = !item.opened)
                            }, [
                              (item.opened)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-up" })
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-sm" }, "View Details", -1)),
                                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-down" })
                                  ]))
                            ], 8, _hoisted_55)
                          ]),
                          _createVNode(_Transition, null, {
                            default: _withCtx(() => [
                              (item.opened)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _cache[60] || (_cache[60] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Basic Information ", -1)),
                                    _createElementVNode("table", _hoisted_59, [
                                      _createElementVNode("tr", null, [
                                        _cache[42] || (_cache[42] = _createElementVNode("td", null, "Name", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[43] || (_cache[43] = _createElementVNode("td", null, "Title", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.title), 1)
                                      ]),
                                      (_unref(valid)(item.pronouns))
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [
                                            _cache[44] || (_cache[44] = _createElementVNode("td", null, "Pronouns", -1)),
                                            _createElementVNode("td", null, _toDisplayString(item.pronouns), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_unref(valid)(item.position))
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                                            _cache[45] || (_cache[45] = _createElementVNode("td", null, "Position", -1)),
                                            _createElementVNode("td", null, _toDisplayString(item.position), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("tr", null, [
                                        _cache[46] || (_cache[46] = _createElementVNode("td", null, "Years of Experience", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.yearsOfExp), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[47] || (_cache[47] = _createElementVNode("td", null, "Level of Education", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.levelEducation), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[48] || (_cache[48] = _createElementVNode("td", null, "Area of Specialization", -1)),
                                        _createElementVNode("td", null, _toDisplayString(JSON.parse(item.expertise || "[]").join(", ")), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[49] || (_cache[49] = _createElementVNode("td", null, "Professional License", -1)),
                                        _createElementVNode("td", null, _toDisplayString(JSON.parse(item.profLicense || "[]").join(", ")), 1)
                                      ])
                                    ]),
                                    _cache[61] || (_cache[61] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Organization Basic Information ", -1)),
                                    _createElementVNode("table", _hoisted_62, [
                                      _createElementVNode("tr", null, [
                                        _cache[50] || (_cache[50] = _createElementVNode("td", null, "Organization", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.nameOrg), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[51] || (_cache[51] = _createElementVNode("td", null, "Location", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.city) + " " + _toDisplayString(item.state), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[52] || (_cache[52] = _createElementVNode("td", null, "Type of Organization", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.type), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[53] || (_cache[53] = _createElementVNode("td", null, "Size of Organization", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.size), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[54] || (_cache[54] = _createElementVNode("td", null, "Gender Diversity", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.genderDiv), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[55] || (_cache[55] = _createElementVNode("td", null, "Racial Diversity", -1)),
                                        _createElementVNode("td", null, _toDisplayString(item.ethnicDiv), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _cache[56] || (_cache[56] = _createElementVNode("td", null, "Website", -1)),
                                        _createElementVNode("td", null, [
                                          (!item.website.startsWith('http'))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: 'https://' + item.website,
                                                target: "_blank"
                                              }, _toDisplayString(item.website), 9, _hoisted_63))
                                            : (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                href: item.website,
                                                target: "_blank"
                                              }, _toDisplayString(item.website), 9, _hoisted_64))
                                        ])
                                      ]),
                                      (_unref(valid)(item.typeProject))
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_65, [
                                            _cache[57] || (_cache[57] = _createElementVNode("td", null, "Types of Projects", -1)),
                                            _createElementVNode("td", null, _toDisplayString(JSON.parse(item.typeProject || "[]").join(", ")), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_unref(valid)(item.typeTechnology))
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [
                                            _cache[58] || (_cache[58] = _createElementVNode("td", null, "Technologies Used", -1)),
                                            _createElementVNode("td", null, _toDisplayString(JSON.parse(item.typeTechnology || "[]").join(", ")), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_unref(valid)(item.organPolicy))
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                                            _cache[59] || (_cache[59] = _createElementVNode("td", null, "Support Policy", -1)),
                                            _createElementVNode("td", null, _toDisplayString(item.organPolicy), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          (
                      course.status !== '20' &&
                      course.status !== '10' &&
                      course.status !== '60'
                    )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary mt-2 text-align-center",
                                onClick: ($event: any) => (selectIndustryPractitioner(item))
                              }, " Select Practitioner ", 8, _hoisted_68))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "layout"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(isVisible))
      ? (_openBlock(), _createBlock(_unref(Dialog), {
          key: 0,
          visible: _unref(isVisible),
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
          modal: "",
          header: "Provide Course Support",
          style: { width: '40vw', padding: '20px', backgroundColor: '#fff' },
          breakpoints: { '768px': '75vw' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Form), {
              onSubmit: saveSelectedPractitioners,
              "validation-schema": _unref(schema)
            }, {
              default: _withCtx(({ meta }) => [
                _createElementVNode("div", _hoisted_69, [
                  _cache[62] || (_cache[62] = _createElementVNode("div", { style: {"display":"flex","justify-content":"space-between","height":"100%"} }, [
                    _createElementVNode("label", { for: "msg" }, "Please provide any message you would like to send to practitioner")
                  ], -1)),
                  _createVNode(_unref(Field), {
                    name: "msg",
                    type: "text",
                    class: "form-control",
                    style: {"height":"200px"},
                    as: "textarea",
                    value: getCustomMsg()
                  }, null, 8, ["value"]),
                  _createVNode(_unref(ErrorMessage), {
                    name: "msg",
                    class: "error-feedback"
                  })
                ]),
                _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-block",
                    disabled: _unref(loading) || !meta.valid
                  }, [
                    _withDirectives(_createElementVNode("span", _hoisted_72, null, 512), [
                      [_vShow, _unref(loading)]
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("span", null, "Send to Industry Practitioners", -1))
                  ], 8, _hoisted_71)
                ])
              ]),
              _: 1,
              __: [64]
            }, 8, ["validation-schema"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_unref(isVisible))
      ? (_openBlock(), _createBlock(_unref(Dialog), {
          key: 1,
          visible: _unref(isPractitionerDetailsVisible),
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isPractitionerDetailsVisible) ? (isPractitionerDetailsVisible).value = $event : isPractitionerDetailsVisible = $event)),
          modal: "",
          style: { width: '60vw', padding: '20px', backgroundColor: '#fff' },
          breakpoints: { '768px': '90vw' }
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("span", _hoisted_74, _toDisplayString(_unref(currIndustryPractitioner)?.firstName +
          " " +
          _unref(currIndustryPractitioner)?.lastName), 1),
              _cache[65] || (_cache[65] = _createTextVNode(", ")),
              _createElementVNode("i", null, _toDisplayString(_unref(currIndustryPractitioner)?.position +
          " at " +
          _unref(currIndustryPractitioner).nameOrg), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[84] || (_cache[84] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Basic Information ", -1)),
              _createElementVNode("table", _hoisted_75, [
                _createElementVNode("tr", null, [
                  _cache[66] || (_cache[66] = _createElementVNode("td", null, "Name", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).firstName +
              " " +
              _unref(currIndustryPractitioner).lastName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[67] || (_cache[67] = _createElementVNode("td", null, "Title", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner)?.title), 1)
                ]),
                (_unref(valid)(_unref(currIndustryPractitioner).pronouns))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                      _cache[68] || (_cache[68] = _createElementVNode("td", null, "Pronouns", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).pronouns), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(valid)(_unref(currIndustryPractitioner).position))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_77, [
                      _cache[69] || (_cache[69] = _createElementVNode("td", null, "Position", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).position), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _cache[70] || (_cache[70] = _createElementVNode("td", null, "Years of Experience", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).yearsOfExp), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[71] || (_cache[71] = _createElementVNode("td", null, "Level of Education", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).levelEducation), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[72] || (_cache[72] = _createElementVNode("td", null, "Area of Specialization", -1)),
                  _createElementVNode("td", null, _toDisplayString(JSON.parse(_unref(currIndustryPractitioner)?.expertise || '[""]').join(
                  ", "
                )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[73] || (_cache[73] = _createElementVNode("td", null, "Professional License", -1)),
                  _createElementVNode("td", null, _toDisplayString(JSON.parse(_unref(currIndustryPractitioner)?.profLicense || '[""]').join(
                ", "
              )), 1)
                ])
              ]),
              _cache[85] || (_cache[85] = _createElementVNode("h5", { class: "text-align-center font-italic font-bold" }, " Practitioner’s Organization Basic Information ", -1)),
              _createElementVNode("table", _hoisted_78, [
                _createElementVNode("tr", null, [
                  _cache[74] || (_cache[74] = _createElementVNode("td", null, "Organization", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner)?.nameOrg), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[75] || (_cache[75] = _createElementVNode("td", null, "Location", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).city +
              " " +
              _unref(currIndustryPractitioner).state), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[76] || (_cache[76] = _createElementVNode("td", null, "Type of Organization", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).type), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[77] || (_cache[77] = _createElementVNode("td", null, "Size of Organization", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).size), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[78] || (_cache[78] = _createElementVNode("td", null, "Gender Diversity of Organization", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).genderDiv), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[79] || (_cache[79] = _createElementVNode("td", null, "Racial Diversity of Organization", -1)),
                  _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).ethnicDiv), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[80] || (_cache[80] = _createElementVNode("td", null, "Website of Organization", -1)),
                  _createElementVNode("td", null, [
                    (!_unref(currIndustryPractitioner).website.startsWith('http'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: 'https://' + _unref(currIndustryPractitioner).website,
                          target: "_blank"
                        }, _toDisplayString(_unref(currIndustryPractitioner).website), 9, _hoisted_79))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _unref(currIndustryPractitioner).website,
                          target: "_blank"
                        }, _toDisplayString(_unref(currIndustryPractitioner).website), 9, _hoisted_80))
                  ])
                ]),
                (_unref(valid)(_unref(currIndustryPractitioner).typeProject))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                      _cache[81] || (_cache[81] = _createElementVNode("td", null, "Types of Projects Executed", -1)),
                      _createElementVNode("td", null, _toDisplayString(JSON.parse(_unref(currIndustryPractitioner)?.typeProject || '[""]').join(
                ", "
              )), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(valid)(_unref(currIndustryPractitioner).typeTechnology))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                      _cache[82] || (_cache[82] = _createElementVNode("td", null, "Types of Technologies Adopted by Practitioner's Organization", -1)),
                      _createElementVNode("td", null, _toDisplayString(JSON.parse(
                _unref(currIndustryPractitioner)?.typeTechnology || '[""]'
              ).join(", ")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(valid)(_unref(currIndustryPractitioner).organPolicy))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_83, [
                      _cache[83] || (_cache[83] = _createElementVNode("td", null, "Company's Effort to Support Student Development", -1)),
                      _createElementVNode("td", null, _toDisplayString(_unref(currIndustryPractitioner).organPolicy), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_unref(isVisible))
      ? (_openBlock(), _createBlock(_unref(Dialog), {
          key: 2,
          visible: _unref(isPractitionerExperienceVisible),
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isPractitionerExperienceVisible) ? (isPractitionerExperienceVisible).value = $event : isPractitionerExperienceVisible = $event)),
          modal: "",
          style: { width: '60vw', padding: '20px', backgroundColor: '#fff' },
          breakpoints: { '768px': '90vw' }
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(currIndustryPractitioner)?.firstName +
          " " +
          _unref(currIndustryPractitioner)?.lastName), 1),
              _cache[86] || (_cache[86] = _createTextVNode(", ")),
              _createElementVNode("i", null, _toDisplayString(_unref(currIndustryPractitioner)?.position +
          " at " +
          _unref(currIndustryPractitioner).nameOrg), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_86, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pastExperienceData), (currRow) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: currRow.courseRequestType
                  }, [
                    _createElementVNode("td", null, _toDisplayString(currRow.courseRequestType), 1),
                    _createElementVNode("td", null, _toDisplayString(currRow.count_exp), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})